import { Component, signal } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Router, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common'; // ✅ เพิ่มตรงนี้
import { VatSettingService } from '../../../core/services/vat-setting.service';
import { MenuCommandPaletteComponent } from '../menu-command-palette/menu-command-palette.component';
@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    // FooterComponent,
    SidebarComponent,
    MenuCommandPaletteComponent,
    NgIf,
  ],
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.css'],
})
export class PrivateLayoutComponent {
  showSidebar = signal(false);
  disableHeader = false;

  constructor(
    private router: Router,
    private vatSetting: VatSettingService,
  ) { }

  ngOnInit(): void {
    this.vatSetting.ensureLoaded();
    const splitPath = this.router.url.split('/');
    this.disableHeader = splitPath[splitPath.length - 2] === 'invoice-fulltax';
    console.log(this.disableHeader);
  }

  toggleSidebar() {
    this.showSidebar.update((v) => !v);
  }

  closeSidebar() {
    this.showSidebar.set(false);
  }
}
